import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import OtpInput from "components/common/OtpInput";

function findFailedOriginal(err, pendingPayload) {
    if (!pendingPayload || !Array.isArray(pendingPayload)) return null;

    const byUnique = err?.uniqueId
        ? pendingPayload.find((p) => p?.uniqueId && p.uniqueId === err.uniqueId)
        : null;
    if (byUnique) return byUnique;

    return pendingPayload.find(
        (p) =>
            p?.postingType === err?.postingType && p?.matterID === err?.matterID,
    );
}

export default function PostingAuthDialog({
    failedPostings,
    pendingPayload,
    authCode,
    authErrorMsg,
    onAuthCodeChange,
    onClose,
    onAuthorise,
}) {
    return (
        <Dialog title={null} onClose={onClose} className="dialog-sm">
            <div className="d-flex flex-column align-items-center justify-content-center px-5 py-4 text-center w-100">
                <span className="k-icon k-i-warning fs-1 text-warning mb-3" />
                <h2 className="mb-3 fw-semibold" style={{ color: "#7d7ab4" }}>
                    Authorisation Required
                </h2>
                <p className="mb-2 text-secondary">
                    Some postings will overdraw an account and require authorisation.
                </p>
                {failedPostings.length > 0 && (
                    <ul
                        className="list-unstyled mt-2 w-100 overflow-auto"
                        style={{ maxHeight: 350 }}
                    >
                        {failedPostings.map((err, idx) => {
                            const original = findFailedOriginal(err, pendingPayload) || {};
                            return (
                                <li
                                    key={idx}
                                    className="d-flex align-items-start mb-2 bg-light rounded p-3 text-start shadow-sm"
                                >
                                    <div className="w-100">
                                        <div className="d-flex justify-content-between gap-3 flex-wrap">
                                            <div>
                                                <b>Type:</b> {err.postingType}
                                            </div>
                                            <div>
                                                <b>Matter Ref:</b> {err.matterRef}
                                            </div>
                                            {original?.reference && (
                                                <div>
                                                    <b>Ref:</b> {original.reference}
                                                </div>
                                            )}
                                            {original?.date && (
                                                <div>
                                                    <b>Date:</b>{" "}
                                                    {new Date(original.date).toLocaleDateString()}
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex justify-content-between gap-3 flex-wrap mt-2">
                                            {original?.details && (
                                                <div className="flex-grow-1">
                                                    <b>Details:</b> {original.details}{" "}
                                                </div>
                                            )}
                                            {typeof original?.netAmount !== "undefined" && (
                                                <div>
                                                    <b>Net:</b> {original.netAmount}
                                                </div>
                                            )}
                                            {typeof original?.vatAmount !== "undefined" && (
                                                <div>
                                                    <b>VAT:</b> {original.vatAmount}
                                                </div>
                                            )}
                                        </div>
                                        {err.message && (
                                            <div className="d-flex gap-2 mt-2">
                                                <b>Message:</b>{" "}
                                                <p className="text-danger mb-0">{err.message}</p>
                                            </div>
                                        )}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                )}
                <div className="w-100 mt-3 d-flex flex-column align-items-center justify-content-center">
                    <label className="mb-2 fw-bold">Authorisation Code</label>
                    <OtpInput
                        value={authCode}
                        onChange={onAuthCodeChange}
                        onComplete={onAuthCodeChange}
                        length={4}
                    />
                    {authErrorMsg && (
                        <p className="mt-2 text-danger">{authErrorMsg}</p>
                    )}
                </div>
            </div>

            <DialogActionsBar layout="end">
                <div className="dialog-footer">
                    <Button
                        onClick={onClose}
                        className="common-btn bgBtnSecondary border-0 me-2"
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={authCode.length !== 4}
                        onClick={onAuthorise}
                        className="common-btn me-4"
                    >
                        Post
                    </Button>
                </div>
            </DialogActionsBar>
        </Dialog>
    );
}
